<template>
  <div id="login" class="text-center container py-5">
    <div class="row">
      <div
        class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-md-10 offset-md-1"
      >
        <div
          class="container"
          v-if="app_chk((draft_order_obj || {}).join_3hour_circuit_id)"
        >
          <h1 class="h4 mb-3 font-weight-normal" v-if="lc_freshman_flg">
            ロードレース フレッシュマン サーキットライセンス所有確認 回答ページ
          </h1>
          <h1 class="h4 mb-3 font-weight-normal" v-else>
            ロードレース 走行時間確認 回答ページ
          </h1>
          <div class="mb-3">
            <div :class="'alert ' + alertClass">
              {{ alertMessage }}
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4 mb-2">サーキット名</div>
            <div class="col-8 mb-2">
              {{
                (get_circuit(draft_order_obj.join_3hour_circuit_id) || {}).label
              }}
            </div>
            <div class="col-4 mb-2">サーキットライセンスNo.</div>
            <div class="col-8 mb-2">
              {{ draft_order_obj.join_3hour_circuit_license_no }}
            </div>
            <div class="col-4">照会対象者名</div>
            <div class="col-8" v-if="application_obj?.m_id == 0">
              {{
                (this.get_app_item('mfj_member_data@name_1') || {})
                  .application_value
              }}
              {{
                (this.get_app_item('mfj_member_data@name_2') || {})
                  .application_value
              }}
            </div>
            <div class="col-8" v-else-if="application_obj?.m_id > 0">
              {{ (member_obj || {}).name_label }}
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4 mb-2">MFJ依頼者</div>
            <div class="col-8 mb-2">
              {{ draft_order_obj.join_3hour_circuit_chk_req_manage_label }}
            </div>
            <div class="col-4">依頼日時</div>
            <div class="col-8">
              {{ draft_order_obj.join_3hour_circuit_chk_req_date }}
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4">対応担当者</div>
            <div class="col-8">
              <input
                v-if="get_mode == 'form'"
                type="text"
                v-model="join_3hour_circuit_chk_ans_signature"
                class="form-control"
                placeholder="ご担当者の方のお名前をご入力下さい"
              />
              <input
                v-else-if="get_mode == 'finish'"
                type="text"
                v-model="join_3hour_circuit_chk_ans_signature"
                class="form-control-plaintext"
                placeholder="ご担当者の方のお名前をご入力下さい"
              />
            </div>
          </div>
          <div class="row mb-4">
            <div class="col-4 mb-2">照会対象者の有無</div>
            <div class="col-8 mb-2">
              <bs-select
                v-if="get_mode == 'form'"
                :options="list_data_1"
                v-model="join_3hour_circuit_chk_ans_data_1"
                :null-option="true"
                :classParam="'form-select'"
              ></bs-select>
              <input
                v-else-if="get_mode == 'finish'"
                type="text"
                :value="
                  get_list_label(join_3hour_circuit_chk_ans_data_1, list_data_1)
                "
                class="form-control-plaintext"
                placeholder=""
              />
            </div>
            <div class="col-4 mb-2" v-if="lc_freshman_flg">
              サーキットライセンス保有状況
            </div>
            <div class="col-4 mb-2" v-else>現時点での走行時間</div>
            <div class="col-8 mb-2">
              <bs-select
                v-if="get_mode == 'form'"
                :options="list_data_2"
                v-model="join_3hour_circuit_chk_ans_data_2"
                :null-option="true"
                :classParam="'form-select'"
                :disabled="ans_data_2_abled ? false : true"
              ></bs-select>
              <input
                v-else-if="get_mode == 'finish'"
                type="text"
                :value="
                  get_list_label(join_3hour_circuit_chk_ans_data_2, list_data_2)
                "
                class="form-control-plaintext"
                placeholder=""
              />
            </div>
          </div>
          <div class="row" v-if="get_mode == 'form'">
            <div class="col-4 offset-4">
              <div class="d-grid">
                <button type="submit" @click="answer" class="btn btn-primary">
                  回答する
                </button>
              </div>
            </div>
          </div>
          <div class="row" v-else-if="get_mode == 'finish'">
            <div class="col-4 offset-4">
              <div class="d-grid">回答済です</div>
            </div>
            <div class="col-4">
              <div class="d-grid">
                <button
                  type="submit"
                  @click="chg_mode('form')"
                  class="btn btn-warning"
                >
                  再度回答する
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="container" v-else>
          <h1 class="h4 mb-3 font-weight-normal">走行確認</h1>
          <div class="mb-3">
            <div :class="'alert alert-warning'">パスコードを入力して下さい</div>
          </div>

          <div class="row mb-4">
            <div class="col-4">パスコード</div>
            <div class="col-8">
              <input
                type="text"
                v-model="input_pass_cd"
                class="form-control"
                placeholder="パスコード"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-4 offset-4">
              <div class="d-grid">
                <button
                  type="submit"
                  @click="chk_pass_cd"
                  class="btn btn-primary"
                >
                  パスコードを入力する
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '../../const'
import BsSelect from '../atoms/BsSelect.vue'
import Common from '../../common/common'
export default {
  name: 'CircuitChk',
  data: function () {
    return {
      draft_order_obj: {},
      application_obj: {},
      member_obj: {},
      circuit_obj: [],
      alertMessage: 'サーキット確認',
      alertClass: 'alert-warning',
      pass_cd: '',
      input_pass_cd: '',
      page_mode: 'form',
      join_3hour_circuit_chk_ans_signature: '',
      join_3hour_circuit_chk_ans_data_1: '',
      join_3hour_circuit_chk_ans_data_2: '',
      ans_data_2_abled: false,
      list_data_1: [
        {
          key: 1,
          label: '該当者有'
        },
        {
          key: 0,
          label: '該当者無'
        }
      ],
      list_data_2_freshman: [
        {
          key: 1,
          label: '適切なライセンスを保有している'
        },
        {
          key: 0,
          label: '適切なライセンスを保有していない'
        }
      ],
      list_data_2_basic: [
        {
          key: 1,
          label: '3時間以上'
        },
        {
          key: 0,
          label: '3時間未満'
        }
      ]
    }
  },
  watch: {
    join_3hour_circuit_chk_ans_data_1(newVal) {
      if (newVal == 1) {
        this.ans_data_2_abled = true
      } else {
        this.ans_data_2_abled = false
        this.join_3hour_circuit_chk_ans_data_2 = ''
      }
    }
  },
  methods: {
    async chg_mode(mode) {
      this.page_mode = mode
    },
    async chk_pass_cd() {
      this.pass_cd = this.input_pass_cd
    },
    async answer() {
      if (this.join_3hour_circuit_chk_ans_signature == '') {
        alert('ご担当者様のお名前をご記入下さい')
        return true
      } else if (this.join_3hour_circuit_chk_ans_data_1 == '') {
        alert('照会対象者の有無を選択して下さい')
        return true
      } else if (
        this.join_3hour_circuit_chk_ans_data_1 == 1 &&
        this.join_3hour_circuit_chk_ans_data_2 == ''
      ) {
        alert('現時点での走行時間を選択して下さい')
        return true
      } else if (window.confirm('回答します。よろしいですか？')) {
        const params = this.draft_order_obj
        params.join_3hour_circuit_chk_ans_signature =
          this.join_3hour_circuit_chk_ans_signature
        params.join_3hour_circuit_chk_ans_data_1 =
          this.join_3hour_circuit_chk_ans_data_1
        params.join_3hour_circuit_chk_ans_data_2 =
          this.join_3hour_circuit_chk_ans_data_2
        params.join_3hour_circuit_chk_ans_date = Common.getNowDateStr()

        await this.nonloginPosts_I(
          config.BASE_API_URL + '/sales_draft_order/edit/' + params.id,
          params
        )
          .then(async response => {
            console.log('update member response', response)
            if (
              typeof response === 'object' &&
              response.data &&
              response.data &&
              response.data.status == '200'
            ) {
              this.alertMessage = '回答しました'
              this.alertClass = 'alert-success'
              this.page_mode = 'finish'
            } else if (
              typeof response === 'object' &&
              typeof response.data === 'object' &&
              response.data.status == '500'
            ) {
              console.log(
                'error update status 500',
                response.data.alert.error_obj
              )
              this.alertMessage = '回答できませんでした'
              this.alertClass = 'alert-danger'
            } else {
              this.alertMessage = '回答できませんでした'
              this.alertClass = 'alert-danger'
            }
          })
          .catch(err => {
            console.log(err)
            this.alertMessage = '回答できませんでした'
            this.alertClass = 'alert-danger'
          })
          .finally(async () => {
            const obj = { ...this.application_obj }
            obj.application_check_type = 340
            await this.update_app(obj)

            this.$forceUpdate()
            // alert(this.alertMessage);
          })
      }
      return true
    },
    async update_app(params) {
      await this.nonloginPosts_I(
        config.BASE_API_URL + '/member_application/edit/' + params.id,
        params
      )
        .then(async response => {
          console.log('update member response', response)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(async () => {
          await this.loadApplicationObj(params.id)
        })
    },
    async loadCircuitObj() {
      const params = {}
      params['stat'] = [1]
      await this.nonloginPosts_S(config.BASE_API_URL + '/circuit/lists', params)
        .then(async response => {
          console.log('loadCircuitList response', response)
          this.circuit_obj =
            response.data && response.data.body ? response.data.body : []
        })
        .catch(async err => {
          console.log(err)
          this.circuit_obj = []
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadDraftOrderObj() {
      const params = {}
      params['stat'] = [1]
      params['select_token'] = this.$route.query.token
      await this.nonloginPosts_S(
        config.BASE_API_URL + '/sales_draft_order/lists',
        params
      )
        .then(async response => {
          console.log('loadDraftOrderObj!!!', response)
          if (response.data && response.data.status == 200) {
            this.draft_order_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            console.log(
              'this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1',
              this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1
            )
            if (
              // (this.draft_order_obj?.join_3hour_circuit_chk_ans_signature !=
              //   '' ||
              //   this.draft_order_obj?.join_3hour_circuit_chk_ans_signature !=
              //     'null') &&
              // (this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1 != '' ||
              //   this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1 !=
              //     'NULL' ||
              //   this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1 !=
              //     'null') &&
              // (this.draft_order_obj?.join_3hour_circuit_chk_ans_data_2 != '' ||
              //   this.draft_order_obj?.join_3hour_circuit_chk_ans_data_2 !=
              //     'NULL' ||
              //   this.draft_order_obj?.join_3hour_circuit_chk_ans_data_2 !=
              //     'null')
              this.draft_order_obj?.join_3hour_circuit_chk_ans_signature &&
              [0, 1].includes(
                parseInt(
                  this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1
                )
              ) &&
              [0, 1].includes(
                parseInt(
                  this.draft_order_obj?.join_3hour_circuit_chk_ans_data_2
                )
              )
            ) {
              this.join_3hour_circuit_chk_ans_signature =
                this.draft_order_obj?.join_3hour_circuit_chk_ans_signature
              this.join_3hour_circuit_chk_ans_data_1 =
                this.draft_order_obj?.join_3hour_circuit_chk_ans_data_1
              this.join_3hour_circuit_chk_ans_data_2 =
                this.draft_order_obj?.join_3hour_circuit_chk_ans_data_2
              this.page_mode = 'finish'
              this.alertMessage = '回答済です'
            }
            // check
            else if (this.lc_freshman_flg) {
              this.alertMessage =
                '対応担当者様のご記名 と 照会対象者の有無 ／ サーキットライセンス保有状況 にご回答ください。'
            } else {
              this.alertMessage =
                '対応担当者様のご記名 と 照会対象者の有無 ／ 現時点での走行時間 にご回答ください。'
            }
          } else {
            this.update_error = true
            this.draft_order_obj = {}
            this.alertMessage = 'データが見つかりませんでした。'
          }
        })
        .catch(async err => {
          this.message = err
          this.draft_order_obj = {}
          console.log('error', err)
        })
        .finally(async () => {
          await this.loadApplicationObj(this.draft_order_obj.application_id)
          this.$forceUpdate()
        })
    },
    async loadApplicationObj(application_id) {
      const params = {}
      params['stat'] = [1]
      params['id'] = application_id
      await this.nonloginPosts_S(
        config.BASE_API_URL + '/member_application/lists',
        params
      )
        .then(async response => {
          console.log('loadApplicationObj!!!', response)
          if (response.data && response.data.status == 200) {
            this.application_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
            if (this.application_obj?.m_id > 0)
              await this.loadMemberObj(this.application_obj?.m_id)
          } else {
            this.update_error = true
            this.application_obj = {}
            this.alertMessage = 'データが見つかりませんでした。'
          }
        })
        .catch(async err => {
          this.message = err
          this.application_obj = {}
          console.log('error', err)
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    },
    async loadMemberObj(m_id) {
      const params = {}
      params['stat'] = [1]
      params['id'] = m_id
      await this.nonloginPosts_S(config.BASE_API_URL + '/member/lists', params)
        .then(async response => {
          console.log('loadMemberObj!!!', response)
          if (response.data && response.data.status == 200) {
            this.member_obj =
              response.data && response.data.body && response.data.body[0]
                ? response.data.body[0]
                : {}
          } else {
            this.update_error = true
            this.member_obj = {}
            this.alertMessage = 'データが見つかりませんでした。'
          }
        })
        .catch(async err => {
          this.message = err
          this.member_obj = {}
          console.log('error', err)
        })
        .finally(async () => {
          this.$forceUpdate()
        })
    }
  },
  components: {
    //   BsPageTitle,
    BsSelect
    //   BsMsgAlert,
    // BsCheckBox,
  },
  async created() {
    console.log('created')
    await this.loadCircuitObj()
    await this.loadDraftOrderObj()
  },
  mounted() {
    // this.handleLogout();
    console.log('mounted logout')
  },
  computed: {
    ...mapState({
      // sex_type_list: state => state.apidata.sex_type,
    }),
    list_data_2: function () {
      if (this.lc_freshman_flg) {
        return [...this.list_data_2_freshman]
      }
      return [...this.list_data_2_basic]
    },
    // draft_order_obj.license_idを元にフレッシュマンor国内かを調べたい。
    lc_freshman_flg: function () {
      if (this.draft_order_obj?.license_id == 2) {
        return true
      }
      return false
    },
    get_list_label: function () {
      return function (key, lists) {
        if (
          key &&
          typeof lists === 'object' &&
          lists.find(list => list.key == key)
        ) {
          return (lists.find(list => list.key == key) || {}).label
        }
        return key
      }
    },
    get_mode: function () {
      return this.page_mode
      //
    },
    app_chk: function () {
      const pass_cd = this.pass_cd
      const circuit_data = this.get_circuit
      return function (circuit_id) {
        const circuit = circuit_data(circuit_id)
        if (
          pass_cd != '' &&
          typeof circuit === 'object' &&
          pass_cd == circuit.pass_cd
        ) {
          return true
        }
        return false
      }
    },
    get_circuit: function () {
      const circuits = this.circuit_obj
      return function (circuit_id) {
        return circuits.find(circuit => circuit.id == circuit_id)
      }
    },
    app_items: function () {
      return (this.application_obj || {}).items
        ? (this.application_obj || {}).items
        : false
    },
    get_app_item: function () {
      const items = this.app_items
      return function (app_key) {
        if (
          typeof items === 'object' &&
          items.find(item => item.application_key == app_key)
        ) {
          return items.find(item => item.application_key == app_key)
        }
        return false
      }
    }
  }
}
</script>

<style scoped>
/* @import "../../assets/bootstrap/css/signin.css"; */
</style>
